import React, {useState} from "react";
import {useHistory} from "react-router";
import SportelliService from "../../../services/SportelliService";
import FormSportello from "./FormSportello";
import Enums from "../../../utils/Enums.json"

function InserisciSportello(props){

    const history = useHistory()
    const [state, setState] = useState({comune: {}, indirizzo: "",cap: "", latitudine: "", longitudine: "", referente: "", telefono: "", email: "", orari: {}, appuntamento:"",note:""})
    const [showSpinner, setShowSpinner] = useState(false)
    const [rerenderAutocomplete,setRerenderAutoComplete] = useState(0)
    const [disabledButtonSalvaModifica,setDisabledButtonSalvaModifica] = useState(true)

    function onChange(id, value) {
        let newState = {...state}

        if(id === "latitudine" || id === "longitudine") {
            let reg = new RegExp('^[\\.0-9]*$');

            let punti = (value.match(/\./g) || []).length

            if (punti <= 1) {
                let controlloNumerico = reg.test(value)

                if (controlloNumerico) {
                    if (!value.includes(".") && value.length === 3) {
                        newState[id] = value.substring(0, 2) + "." + value.substring(value.length - 1)
                    } else {
                        newState[id] = value
                    }
                    setState(newState)
                }
            }
        }
        else {
            newState[id] = value
            if (id==="appuntamento" && value===true){
                newState.orari={}
            }
            setState(newState)
        }

        disabledSalvaModifica(newState)
    }

    function onChangeOrari(id, value) {
        let newState = {...state}
        newState.orari[id] = value
        setState(newState)
    }

    function disabledSalvaModifica(newState) {
        if (!newState || !newState.comune || !newState.comune.descrizione || !newState.indirizzo ||
            !newState.referente || !newState.telefono || !newState.email || !newState.latitudine || !newState.longitudine || !newState.cap) {
            return setDisabledButtonSalvaModifica(true)
        } else {
            return setDisabledButtonSalvaModifica(false)
        }
    }

    function salvaSportello() {
        setShowSpinner(true)
        let sportelloDaSalvare = {...state}
        SportelliService.inserisciSportello(sportelloDaSalvare).then(res => {
            if (res.status === 200) {
                props.getSportelli()
            } else {
                history.push({
                    pathname: "/errore"
                })
            }
            setState({comune: {}, indirizzo: "", cap: "", latitudine: "", longitudine: "",referente: "", telefono: "", email: "", orari: {},appuntamento: "",note: ""})
            setRerenderAutoComplete(rerenderAutocomplete+1)
            setShowSpinner(false)
            window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione,"Operazione avvenuta con successo");
        }).catch(reason => {
            window.alert(Enums.TOASTERTYPE.ERROR.descrizione,"Errore durante l'esecuzione dell'operazione");
            console.log("Errore Operation POST Sportelli: " + reason)
            setShowSpinner(false)
        })
    }

    function annullaCreazioneSportello() {
        setState({comune: "", indirizzo: "", cap: "", latitudine: "", longitudine: "",referente: "", telefono: "", email: "", orari: {},appuntamento: "",note: ""})
        setRerenderAutoComplete(rerenderAutocomplete+1)
    }

    return (
        <FormSportello modifica={false} state={state}
                       showSpinner={showSpinner} rerenderAutocomplete={rerenderAutocomplete}
                       onChange={onChange} onChangeOrari={onChangeOrari} disabledButtonSalvaModifica={disabledButtonSalvaModifica}
                       onClickAnnulla={annullaCreazioneSportello} onClickSalvaModifica={salvaSportello}
        />
    )


}
export default InserisciSportello
